
import React from "react";
import RecebimentosTabActions from "./RecebimentosTabActions";

interface RecebimentosTabHeaderProps {
  onAgendarRecebimento: () => void;
  onRegistrarRecebimento: () => void;
}

const RecebimentosTabHeader: React.FC<RecebimentosTabHeaderProps> = ({
  onAgendarRecebimento,
  onRegistrarRecebimento
}) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
      <div>
        <h2 className="text-xl font-semibold text-financeiro-text-DEFAULT">Recebimentos</h2>
        <p className="text-financeiro-text-light mt-1">Gerencie seus recebimentos e pagamentos de clientes</p>
      </div>
      <RecebimentosTabActions 
        onAgendarRecebimento={onAgendarRecebimento}
        onRegistrarRecebimento={onRegistrarRecebimento}
      />
    </div>
  );
};

export default RecebimentosTabHeader;
